export default __webpack_public_path__ + "img/sidebars-1-62ee0ba7.png";